import assign from "lodash/assign";

const useDefault = <T>(obj: Partial<T> | undefined, defaultObj: T): T => {
    return assign({}, defaultObj, obj);
};
export default useDefault;
